
<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item >管理</el-breadcrumb-item>
        <!-- :to="{ path: '/' }" -->
        <el-breadcrumb-item>承诺书审核管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <div style="float: right;margin-right:2%;">
        <el-select @change="dataSelect()" v-model="state" placeholder="请选择">
            <el-option
            v-for="item in states"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
      </div>
  
      <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id" @selection-change="handleSelectionChange">
          <el-table-column
          type="selection"
          width="55">
          </el-table-column>
          <el-table-column align="center" prop="img" label="用户头像">
            <template slot-scope="scope">
                <el-image 
                style="width: 100px; height: 100px"
            :src="scope.row.img" 
            :preview-src-list="[scope.row.img]"></el-image>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="nickName" label="用户名">
          </el-table-column>
          <el-table-column align="center" prop="signs" label="签名">
            <template slot-scope="scope">
                <el-image 
                style="width: 100px; height: 100px"
            :src="scope.row.signs" 
            :preview-src-list="[scope.row.signs]"></el-image>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="outcome" label="识别结果">
          </el-table-column>
          <el-table-column align="center" prop="submitName" label="用户提交的应识别结果">
          </el-table-column>
          <el-table-column align="center" prop="createTime" label="提交时间">
          </el-table-column>
          <el-table-column align="center" prop="state" label="当前状态">
            <template slot-scope="scope">
              <div v-if="scope.row.state === 0">待审核</div>
              <div v-if="scope.row.state === 1">已通过</div>
              <div v-if="scope.row.state === 2">未通过</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" >
            <template slot-scope="scope">
              <el-button size="mini" type="primary"
                  @click="updates(scope.row.id,1)">
                  <i class="el-icon-check"></i>
              </el-button>
              
              <el-button size="mini" type="danger"
                  @click="updates(scope.row.id,2)">
                  <i class="el-icon-close"></i>
              </el-button>
            </template>
        </el-table-column>          
        </el-table>
        <div style="text-align: center;margin-top: 10px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]" :page-size="size" :current-page="page"
            layout="total,sizes, prev, pager, next" :total="totalnum">
          </el-pagination>
        </div>
  
    </div>
  </template>
  
  <script>

  import { getCommitmentAduitRecordList , auditCommitmentAduitRecord } from '../../../api/manage/aduit.js'
  
  import moment from 'moment';
  
  export default {
    data() {
      return {
          startDate:'',
          endDate:'',
          dateTime:'',
          outlet : '',
          multipleSelection: [],
          totalnum:0,
          page : 1 ,
          size : 10,
          tableDataLoading:false,
          dialogFormVisible:false,
          state:0,
          states:[{
                value: 0,
                label: '待审核'
            },
            {
                value: 1,
                label: '已通过'
            },
            {
                value: 2,
                label: '未通过'
            }
        ],
          tableData:[],
         
          updateForm:{
              
          },
  
      }
    },
    components: {
  
    },
  
    created() {
      this.dataSelect()
      // this.getdata(1)
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        updates(id,state){

            let selectedIds = this.multipleSelection.map(item => item.id)
            let idsa= selectedIds.join(',')
            let ids=''
            if(idsa ===''){
                ids=id
            }else{
                ids=idsa
            }

            let post = {
                ids : ids,
                state : state,
            }
            // console.log(ids)
            auditCommitmentAduitRecord(post).then((res) => {
                this.$message({
                    type: "success",
                    message: res.msg,
                    duration: 1500,
                    onClose: () => {
                        this.dataSelect()
                    }
                });
            })
        },

      handleSizeChange(val) {
				this.size = val;
				this.dataSelect()
			},
      handleCurrentChange(val) {
				this.page = val;
				this.dataSelect()
			},

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
  
      dataSelect(){
        let post = {
          page : (this.page - 1 ) * this.size,
          size : this.size,
          state : this.state,
        }
        this.tableDataLoading = true
        getCommitmentAduitRecordList(post).then((res) => {
          this.tableDataLoading = false
          if (res.code == 200) {
              this.tableData = res.data.list
              this.totalnum = res.data.count;
              return;
          }
          this.$message({
              type: "info",
              message: res.msg,
          });
      })
  
      },
  
    }
  }
  </script>
  
  <style scoped>
  .userRole {
    width: 100%;
  
  }
  </style>


// WEBPACK FOOTER //
// src/views/manage/commitment/aduit.vue